_ = require("lodash")

DashboardBasicAnalysisService = ($http, ScoreCardAPIService, $routeParams) ->
  id = $routeParams.user_id
  if ($routeParams.user_id == undefined)
    id =  "me"
  getMyAnalysis: (options={}) ->
    params = _.pickBy
      from: (options.from.format("YYYY-MM-DD") if options.from)
      to: (options.to.format("YYYY-MM-DD") if options.to)
      round_type: options.round_type?.join(',')
    , (v) -> v != null && v != undefined
    ScoreCardAPIService.getMyAvg(id,params)

DashboardBasicAnalysisService.$inject = [
  '$http'
  'ScoreCardAPIService'
  '$routeParams'
]

module.exports = DashboardBasicAnalysisService



// WEBPACK FOOTER //
// ./~/coffeelint-loader!./ngapp/javascript/web/dashboard/basic-analysis/basic-analysis-service.coffee